// extracted by mini-css-extract-plugin
export default {"btn-container":"DownloadCSVButton_btn-container__EG2p+","btn-csv":"DownloadCSVButton_btn-csv__fdtB9"};